import React from "react";
import "./TextCarousel.scss";

const capabilities = [
  "Laundry sheets",
  "Custom labeling",
  "Paper packaging",
  "Bulk cartons",
  "Private label",
  "Sheet production",
  "Sample support",
  "Formula options",
];

function TextCarousel() {
  return (
    <div className="text-carousel-wrapper mobile-type">
      <div
        className="text-carousel-viewport"
        role="region"
        aria-label="Klean Leaf capabilities"
        tabIndex={0}
      >
        <div className="text-carousel">
          {[false, true].map((isDuplicate) => (
            <ul
              className="text-carousel-group"
              aria-hidden={isDuplicate ? "true" : undefined}
              key={String(isDuplicate)}
            >
              {capabilities.map((capability) => (
                <li className="carousel-text" key={capability}>
                  <span>{capability}</span>
                  <span className="carousel-star" aria-hidden="true">✦</span>
                </li>
              ))}
            </ul>
          ))}
        </div>
      </div>
    </div>
  );
}

export default TextCarousel;
